export const environment = {
  IS_PRODUCTION: false,
  IS_DEMO_MODE: false,
  API_BASE_URL: 'https://stageapi.extra.com',
  API_CLIENT_ID: 'web',
  API_CLIENT_SECRET: 'd2ViOmM2SHlvUWVWNTduN1pIZjBHeXFTdm43OHJndUNienNwZXNqOGdJOTQ=',
  TTL_24_DOMAIN: 'extra.com',
  BACKUP_TOKEN: 'h-Qjsw1Anzqu65lAwmgBsQkamqk',
  AMPLIENCE_API_BASE: 'https://bdkbpklt25el1gonxadugljq5.staging.bigcontent.io/content',
  GET_TEST_FREAK_BASE_EN : 'https://js.testfreaks.com/onpage/extra.com-en-staging/reviews.json',
  GET_TEST_FREAK_BASE_AR: 'https://js.testfreaks.com/onpage/extra.com-ar-staging/reviews.json'
};
